<mat-dialog-content>
	<!-- Main modal -->
	<div class="bg-white rounded-lg">
		<div class="flex items-center">
			<div class="mt-4 md:mt-0 md:ml-6 text-center md:text-left">
				<p class="font-bold text-2xl">Are you sure?</p>
				<p class="text-sm text-gray-700 mt-1">
					Do you really want to delete this item?
					This action cannot be undone.<br>
					{{message}}
				</p>
			</div>
		</div>
		<div class="text-center md:text-right mt-4 md:flex md:justify-end">
			<button (click)="closeDialog(true)"
					class="block w-full md:inline-block md:w-auto px-4 py-3 md:py-2 bg-red-200 text-red-700 rounded-lg font-semibold text-sm md:ml-2 md:order-2">
				Delete
			</button>
			<button
				(click)="closeDialog(false)"
				class="block w-full md:inline-block md:w-auto px-4 py-3 md:py-2 bg-gray-200 rounded-lg font-semibold text-sm mt-4
          md:mt-0 md:order-1">Cancel
			</button>
		</div>
	</div>
</mat-dialog-content>
